module.exports = __webpack_public_path__ + "img/desempenho-por-equipe.89ae2d42.svg";